export default __webpack_public_path__ + "43fe8ad488b9aa6deab10e21a9a67607.png";